import { useFormikContext } from 'formik';

import { ItemProps } from '@@/form-components/InputList';
import { Input } from '@@/form-components/Input';
import { FormError } from '@@/form-components/FormError';

import { VulnerabilityScanningFormValues } from './types';

export function NamespacePatternItem({
  item,
  onChange,
  error,
  disabled,
  readOnly,
  index,
}: ItemProps<string>) {
  const { values } = useFormikContext<VulnerabilityScanningFormValues>();
  const placeholder =
    values.namespaceScopeMode === 'all-except' ? 'kube-*' : 'payments';

  return (
    <div className="flex flex-col gap-1">
      <div className="w-72">
        <Input
          value={item}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          data-cy={`vulnerability-scanning-namespace-${index}`}
        />
      </div>
      {typeof error === 'string' && <FormError>{error}</FormError>}
    </div>
  );
}
